import { useQuery } from '@tanstack/react-query'
import { keys } from '../keys'
import { fetchCollections } from '../fetchers/collections'

export const useCollections = () => {
    return useQuery({
        queryKey: keys.collections.all(),
        queryFn: fetchCollections,
    })
}
